export default __webpack_public_path__ + "static/media/afd.b1b5ef69.svg";